import { NgModule } from '@angular/core';

// Componentes
import { ParticipanteListaComponent } from '@app/pages/cadastros/participante/participante-lista/participante-lista.component';
import { ParticipantesFormComponent } from '@app/pages/cadastros/participante/participante-form/participante-form.component';
import { FuncionarioFormComponent } from '@app/pages/cadastros/funcionario/funcionario-form/funcionario-form.component';
import { FuncionariosListaComponent } from '@app/pages/cadastros/funcionario/funcionarios-lista/funcionarios-lista.component';
import { PhLoadingListaComponent } from '@app/components/placeholder-loading/phloading-lista';

// Roteamento
import { CadastrosRoutingModule } from './cadastros.routing';

// Guardas
// import { AuthGuard } from '@app/guards/auth.guard';

// Services
import { ParticipanteService } from '@app/services/participante.service';
import { FuncionarioService } from '@app/services/funcionario.service';

// Terceiros
import { BsModalService } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TextMaskModule } from 'angular2-text-mask';

// Módulos
import { SharedModule } from './../../shared/shared.module';
import { PlanoControleService } from '@app/services/plano-controle.service';

@NgModule({
  declarations: [
    ParticipanteListaComponent,
    ParticipantesFormComponent,
    FuncionarioFormComponent,
    FuncionariosListaComponent,
    PhLoadingListaComponent,
  ],
  imports: [
    SharedModule,
    CadastrosRoutingModule,
    PaginationModule.forRoot(),
    TextMaskModule,
  ],
  providers: [
    // AuthGuard,
    ParticipanteService,
    FuncionarioService,
    BsModalService,
    PlanoControleService
  ]
})
export class CadastrosModule { }
